var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tableComponent',{ref:"tableComponent",attrs:{"tableSettings":_vm.tableSettings,"tableData":_vm.tableData,"headers":_vm.headers,"enable-row-clickable":true},on:{"newDocument":_vm.newDocument,"clickedRow":function($event){return _vm.openCategory($event)},"reloadData":_vm.reloadDataFunc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }